(function () {
    // Variables
    var commentField = document.getElementById('comments');
    const dateInput = document.querySelector('input[type="date"]');

    // Functions
    
    // Function for executing code on document ready
    function domReady(callback) {
        if (['interactive', 'complete'].indexOf(document.readyState) >= 0) {
            callback();
        } else {
            document.addEventListener('DOMContentLoaded', callback);
        }
    }

    // Function for updating character count on Product pages comment field
    function updateCharCount() {
        const maxLength = 255;
        const charCountDisplay = document.getElementById('charCount');
        const currentLength = commentField.value.length;
        
        charCountDisplay.textContent = `${maxLength - currentLength} characters remaining`;
    }

    // Execute JavaScript on document ready
    domReady(function () {
        if (!document.body) {
            return;
        } else {
            // Function dependent on comment field
            if (commentField) {
                commentField.addEventListener('input', updateCharCount);
            }
        
        if (dateInput) {
          const today = new Date();
          const formattedToday = today.toISOString().slice(0, 10);
          dateInput.setAttribute('max', formattedToday);
        }
        }
    });
})();

/*$(document).ready(function() {
  // Validation for payment terms agreement checkbox
  $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      if ($('#agree').is(':checked')) {
        $(this).submit();
      } else {
        $('#error-for-agree').addClass('show-error');
        $('#error-for-agree').removeClass('hidden');
        $('.label-agree').css('color', '#DD1D1D');
        return false;
      }
  });
});*/